import { ChevronLeft } from "lucide-react";

const RefundPolicyPage = ({ navigateTo }) => {
  return (
    <div className="min-h-screen py-16 px-4" style={{ background: "var(--zen-bg)" }}>
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigateTo("landing")}
          className="flex items-center gap-1 text-sm mb-8 hover:opacity-70 transition-opacity"
          style={{ color: "var(--zen-sub)" }}
        >
          <ChevronLeft className="w-4 h-4" /> Back
        </button>

        <h1 className="font-heading text-3xl sm:text-4xl mb-2" style={{ color: "var(--zen-text)" }}>
          Refund Policy
        </h1>
        <p className="text-sm mb-10" style={{ color: "var(--zen-dim)" }}>
          Last updated: March 19, 2026
        </p>

        <div className="space-y-8 text-sm leading-relaxed" style={{ color: "var(--zen-sub)" }}>
          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>Overview</h2>
            <p>
              JapanUnfolded offers digital trip packs that provide AI itinerary
              generations. Because our product is a digital service delivered instantly, our refund policy
              is as follows.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>Full Refund — Unused Credits</h2>
            <p>
              If you have not used any credits from your purchased pack, you may request a full refund
              within <strong style={{ color: "var(--zen-text)" }}>14 days</strong> of purchase.
              To qualify, none of the credits in the pack may have been used for itinerary generation.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>Partial Refund — Partially Used Credits</h2>
            <p>
              If you have used some but not all credits from your pack, we may offer a partial refund
              at our discretion, calculated based on the unused portion. Requests must be made within
              14 days of purchase.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>No Refund</h2>
            <p>Refunds are not available in the following cases:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>All credits in the pack have been used</li>
              <li>More than 14 days have passed since purchase</li>
              <li>The account has been flagged for abuse or violation of our Terms of Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>Technical Issues</h2>
            <p>
              If you experience a technical issue that prevents you from using a credit (e.g., a generation
              fails due to a server error and your credit is consumed), please contact us. We will either
              restore the credit to your account or issue a refund for that generation.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>Free Preview</h2>
            <p>
              The preview of your first trip (its first day in full, the rest as titles) involves no
              payment, so there is nothing to refund.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>How to Request a Refund</h2>
            <p>
              To request a refund, email us at{" "}
              <a href="mailto:support@japanunfolded.ai" className="underline hover:opacity-70" style={{ color: "var(--zen-accent)" }}>
                support@japanunfolded.ai
              </a>{" "}
              with:
            </p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>The email address used for purchase</li>
              <li>The date of purchase</li>
              <li>The package purchased (Discover, Journey, or Unfolded)</li>
              <li>The reason for your refund request</li>
            </ul>
            <p className="mt-3">
              We aim to respond to all refund requests within 2 business days. Approved refunds are
              processed back to the original payment method via Stripe and typically appear within
              5-10 business days.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: "var(--zen-text)" }}>Contact</h2>
            <p>
              Questions about our refund policy? Reach us at{" "}
              <a href="mailto:support@japanunfolded.ai" className="underline hover:opacity-70" style={{ color: "var(--zen-accent)" }}>
                support@japanunfolded.ai
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
